export const RolesEnum = {
    Administrator: "ADMINISTRATOR",
    Employee: "EMPLOYEE",
    AccountOwner: "ACCOUNTOWNER",
    Guest: "GUEST",
    SupplierContact: "SUPPLIERCONTACT"
}
Object.freeze(RolesEnum);